import { getAnalyticsAdapter } from "./AnalyticsAdapter";

function track(event: string, props?: Record<string, string | number | boolean>): void {
  getAnalyticsAdapter().track(event, props);
}

/**
 * Typed facade over the tracking plan: one function per product event, so event
 * names and prop shapes stay consistent across the codebase.
 */
export const analytics = {
  dashboardViewed: (): void => track("dashboard_viewed"),
  contractOpened: (p: { contractId: string; clientId: string }): void =>
    track("contract_opened", p),
  contractStarted: (p: { contractId: string; difficulty: number }): void =>
    track("contract_started", p),
  taskStarted: (p: { type: string }): void => track("task_started", p),
  taskSubmitted: (p: { type: string; score: number }): void => track("task_submitted", p),
  resultViewed: (p: { grade: string }): void => track("result_viewed", p),
  levelUp: (p: { level: number }): void => track("level_up", p),
  clientUnlocked: (p: { clientId: string }): void => track("client_unlocked", p),
  skillUpgraded: (p: { skillId: string; level: number }): void => track("skill_upgraded", p),
  toolPurchased: (p: { toolId: string; cost: number }): void => track("tool_purchased", p),
  achievementUnlocked: (p: { achievementId: string }): void =>
    track("achievement_unlocked", p),
  contractAbandoned: (p: {
    contractId: string;
    clientId: string;
    progressPct: number;
    lastScreen: string;
  }): void => track("contract_abandoned", p),
  settingsOpened: (): void => track("settings_opened"),
  languageChanged: (p: { lang: string }): void => track("language_changed", p),
  consentDeclined: (): void => track("consent_declined"),
  tutorialHintViewed: (p: { hint: string }): void => track("tutorial_hint_viewed", p),
};
